import(/* webpackMode: "eager", webpackExports: ["TalentAppShell"] */ "/app/apps/platform-web/components/talent/app/TalentAppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisaJobFitWizard"] */ "/app/apps/platform-web/components/tools/VisaJobFitWizard.tsx");
